var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCustomDnbMobilebank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 33,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 29a1 1 0 11-2 0 1 1 0 012 0z",
    fill: "#B3B3B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 .5A1.5 1.5 0 00.5 2v29A1.5 1.5 0 002 32.5h16a1.5 1.5 0 001.5-1.5v-8a.5.5 0 00-1 0v2.5h-17V2a.5.5 0 01.5-.5h16a.5.5 0 01.5.5v10a.5.5 0 001 0V2A1.5 1.5 0 0018 .5H2zm-.5 26V31a.5.5 0 00.5.5h16a.5.5 0 00.5-.5v-4.5h-17z",
    fill: "#B3B3B3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 14.5c-1.64 0-2.867.213-3.745.53-.858.31-1.452.745-1.702 1.246a.5.5 0 00-.053.224v2a.5.5 0 00.1.3c.336.447.993.866 1.873 1.172.897.313 2.079.528 3.527.528s2.63-.215 3.527-.528c.88-.306 1.537-.725 1.873-1.172a.5.5 0 00.1-.3v-2a.5.5 0 00-.053-.224c-.25-.5-.844-.937-1.702-1.246-.878-.317-2.105-.53-3.745-.53zm-4.5 3.813v-.774c.281.16.608.306.973.433.897.313 2.079.528 3.527.528s2.63-.215 3.527-.528a5.88 5.88 0 00.973-.433v.774c-.214.21-.634.482-1.302.715-.778.27-1.846.472-3.198.472-1.352 0-2.42-.201-3.198-.472-.668-.233-1.088-.505-1.302-.715zm7.698-1.285c.52-.181.889-.386 1.128-.567-.18-.151-.47-.328-.92-.49-.74-.267-1.846-.471-3.406-.471s-2.666.204-3.405.47c-.45.163-.742.34-.921.491.24.181.608.386 1.128.567.778.27 1.846.472 3.198.472 1.352 0 2.42-.201 3.198-.472z",
    fill: "#B3B3B3"
  })));
}

export default SvgCustomDnbMobilebank;